import { render, staticRenderFns } from "./handleNumModal.vue?vue&type=template&id=0be9be7c&scoped=true&"
import script from "./handleNumModal.vue?vue&type=script&lang=js&"
export * from "./handleNumModal.vue?vue&type=script&lang=js&"
import style0 from "./handleNumModal.vue?vue&type=style&index=0&id=0be9be7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9be7c",
  null
  
)

export default component.exports